@if (!!observation) {
  <p>
    <strong>{{ observation.observationType.title }}</strong>
  </p>

  <table>
    @if (isLiveMap && observation.vehicle) {
      <tr>
        <th>Vehicle:</th>
        <td>
          <a [routerLink]="['/' + RootRoute.MAIN, MainRoute.VEHICLE, observation.vehicle.id]"
             [queryParamsHandling]="'merge'"
             [class.hidden-link]="isLinkActive('/' + RootRoute.MAIN + '/' + MainRoute.VEHICLE)"
             class="view-link"
          >
            {{ observation.vehicle.label | uppercase }}
          </a>
          @if (isLinkActive('/' + RootRoute.MAIN + '/' + MainRoute.VEHICLE)) {
            <span>
              {{ observation.vehicle.label | uppercase }}
            </span>
          }
        </td>
      </tr>
    }
    <tr>
      <th>Location:</th>
      <td (click)="handleLocationClick($event)">{{ [observation.location.longitude, observation.location.latitude] | latLng}}</td>
    </tr>
    <tr>
      <th>Time:</th>
      <td>{{ observation.created | date:'shortDate'}} {{observation.created | date:'mediumTime' }}</td>
    </tr>
    @if (observation.comment) {
      <tr>
        <th>Comments:</th>
        <td>{{ observation.comment }}</td>
      </tr>
    }
  </table>

  @if (isLiveMap && !isActiveShift && observation.shiftId) {
    <div>
      <a [routerLink]="['/' + RootRoute.MAIN, MainRoute.INSIGHTS, InsightsRoute.SHIFT_REPORT, InsightsRoute.SHIFT_DETAIL, observation.shiftId]"
         class="view-link"
      >
        View Shift Detail
      </a>
    </div>
  }

  @if (observation.imageUrl) {
    <div class="dash-cam-image-thumbnail">
      <app-retrying-image-viewer [imageUrl]="observation.imageUrl"
                                 [alternativeText]="'Dashboard Camera Image'"></app-retrying-image-viewer>
    </div>
  }
}
